export const getCartTravelerPrices = (travelers = [], travelerPrices = [], travelerNames = []) =>
  travelers.map((traveler, index) => {
    const {
      price,
      carrierPriceBreakdowns = [],
      taxesAndFees = [],
    } = travelerPrices.find((travelerPrice) => travelerPrice.travelerId === traveler.id) || {};
    const { fullName, firstName, lastName } =
      travelerNames.find((travelerName) => travelerName.travelerId === traveler.id) || {};

    return {
      ageType: traveler.ageType,
      firstName: firstName ?? traveler.firstName,
      fullName: fullName ?? traveler.name,
      lastName: lastName ?? traveler.lastName,
      markup: price?.markup?.value ?? null,
      carrierPriceBreakdowns,
      taxesAndFees,
      totalPrice: price?.price?.value ?? 0,
      totalPriceSum: price?.price?.value ?? 0,
      travelerId: traveler.id || String(index),
      vat: price?.vat?.value ?? null,
    };
  });
